"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateBusinessMarketplaceFeeBodyToJSON = exports.UpdateBusinessMarketplaceFeeBodyFromJSONTyped = exports.UpdateBusinessMarketplaceFeeBodyFromJSON = void 0;
var runtime_1 = require("../runtime");
function UpdateBusinessMarketplaceFeeBodyFromJSON(json) {
    return UpdateBusinessMarketplaceFeeBodyFromJSONTyped(json, false);
}
exports.UpdateBusinessMarketplaceFeeBodyFromJSON = UpdateBusinessMarketplaceFeeBodyFromJSON;
function UpdateBusinessMarketplaceFeeBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'marketplacePercentageDelivery': !(0, runtime_1.exists)(json, 'marketplacePercentageDelivery') ? undefined : json['marketplacePercentageDelivery'],
        'marketplacePercentagePickup': !(0, runtime_1.exists)(json, 'marketplacePercentagePickup') ? undefined : json['marketplacePercentagePickup'],
    };
}
exports.UpdateBusinessMarketplaceFeeBodyFromJSONTyped = UpdateBusinessMarketplaceFeeBodyFromJSONTyped;
function UpdateBusinessMarketplaceFeeBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'marketplacePercentageDelivery': value.marketplacePercentageDelivery,
        'marketplacePercentagePickup': value.marketplacePercentagePickup,
    };
}
exports.UpdateBusinessMarketplaceFeeBodyToJSON = UpdateBusinessMarketplaceFeeBodyToJSON;
